export function getPronoun(gender, language) {
	if (gender === 'm' && (language === 'no' || language === 'nn')) {
		return 'han';
	} else if (gender === 'f' && language === 'no') {
		return 'hun';
	} else if (gender === 'f' && language === 'nn') {
		return 'ho';
	}
	return 'hen';
}
